<template>
  <div>
    <div class='wrapHeader'>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="仓房选择">
          <el-select v-model="params.wareId" clearable placeholder="仓房选择" @change='wareChange'>
            <el-option :label="item.wareName" :value="item.wareId" v-for='item in wareList' :key='item.wareId'></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class='setBgImg' :style='`height:${height}px`'>
      <div class='publicWrap'>
        <div class='showView' :style="`height:${height-20}px;width:${width-30}px`">
          <!-- <el-button type="primary" class='commonBtn refresh' @click="refresh"><i class="el-icon-refresh" style="margin-right:5px"></i>同步数据</el-button> -->
          <el-button type="primary" class='commonBtn upload' @click="upload"><i class="el-icon-upload2" style="margin-right:5px"></i>上传数据</el-button>
          <div class='setMacView' :style="`height:${height-100}px;width:${width-60}px`">
            <el-table
              :data="tableData"
              style="width: 100%"
              :header-cell-style='{"background":"rgba(48,56,255,0.03)"}'
              :max-height="height-149"
              border>
              <el-table-column type="index" width="60" align='center' label="序号" :index="indexMethod"></el-table-column>
              <el-table-column prop="locationName" label="仓房名称" align="center" min-width='100' sortable></el-table-column>
              <el-table-column
                prop="maxGrainTemp"
                label="最高粮温 ℃"
                align="center"
                min-width='100'>
              </el-table-column>
              <el-table-column
                prop="minGrainTemp"
                label="最低粮温 ℃"
                align="center"
                min-width='100'>
              </el-table-column>
              <el-table-column
                prop="avgGrainTemp"
                label="平均粮温 ℃"
                align="center"
                min-width='100'>
              </el-table-column>
              <el-table-column
                prop="innerTemp"
                label="仓内温 ℃"
                align="center"
                min-width='100'
              >
              </el-table-column>
              <el-table-column
                prop="outerTemp"
                label="仓外温 ℃"
                align="center"
                min-width='100'
              >
              </el-table-column>
              <el-table-column
                prop="innerHum"
                label="仓内湿 %RH"
                align="center"
                min-width='100'
              >
              </el-table-column>
              <el-table-column
                prop="outerHum"
                label="仓外湿 %RH"
                align="center"
                min-width='100'
              >
              </el-table-column>
              <el-table-column
                prop="uploadSuccess"
                label="上传状态"
                align="center"
                min-width='100'
                sortable>
                <template slot-scope="scope">
                  <span :class='scope.row.uploadSuccess==1?"upOnLine":(scope.row.uploadSuccess==2?"upOffLine":"upWaiting")'>
                    {{scope.row.uploadSuccess==1?"上传成功":(scope.row.uploadSuccess==2?"上传失败":'未上传')}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="operationFlag"
                min-width="100"
                label="操作类型">
                <template slot-scope="scope">
                  <span 
                    :class='scope.row.operationFlag=="u"?"upOnLine":(scope.row.operationFlag=="d"?"upOffLine":"upWaiting")'>
                    {{scope.row.operationFlag=='u'?'更新数据':(scope.row.operationFlag=='d'?'删除数据':'新增数据')}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="lastUpdateTime"
                label="更新时间"
                min-width='120'>
              </el-table-column>
              <el-table-column label="操作" min-width="120" align='center'>
                <template slot-scope="scope">
                  <el-button @click.native.prevent="viewInfo(scope.row.grainUploadDataId)" type="text" size="small">查看</el-button>
                  <el-button @click.native.prevent="handleDelete(scope.row.grainUploadDataId)" type="text" size="small" v-if="scope.row.uploadSuccess==0">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              background
              layout="total,prev, pager, next"
              :total="total"
              :hide-on-single-page='true'
              :pageSize='params.pageSize' 
              :current-page='params.pageNum'
              @current-change='getOtherLog'
              class='setPosition'>
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="粮温信息详情" :visible.sync="view"
      :close-on-click-modal='false'
      width='800px'
      top='200px'
      :custom-class='"dialog-setBg"'>
      <div class='formWrap'>
        <el-form ref="tempConfig" label-width="100px">
          <div class="dialog-setWrap dialog-setWrap-descriptions">
            <div class="dialog-descriptions" style="flex-grow:1">
              <el-descriptions :column="2" border>
                <el-descriptions-item label="仓房名称" label-class-name="myLabel" content-class-name="myContent">{{info.locationName}}</el-descriptions-item>
                <el-descriptions-item label="货位代码" label-class-name="myLabel" content-class-name="myContent">{{info.locationCode}}</el-descriptions-item>
                <el-descriptions-item label="检测单号" label-class-name="myLabel" :span='2' content-class-name="myContent">{{info.detectionNo}}</el-descriptions-item>
                <el-descriptions-item label="检测时间" label-class-name="myLabel" content-class-name="myContent">{{info.detectionTime}}</el-descriptions-item>
                <el-descriptions-item label="最高温度 ℃" label-class-name="myLabel"  content-class-name="myContent">{{info.maxGrainTemp}}</el-descriptions-item>
                <el-descriptions-item label="最低温度 ℃" label-class-name="myLabel" content-class-name="myContent">{{info.minGrainTemp}}</el-descriptions-item>
                <el-descriptions-item label="平均温度 ℃" label-class-name="myLabel" content-class-name="myContent">{{info.avgGrainTemp}}</el-descriptions-item>
                <el-descriptions-item label="仓内温度 ℃" label-class-name="myLabel" content-class-name="myContent">{{info.innerTemp}}</el-descriptions-item>
                <el-descriptions-item label="仓内湿度 %RH" label-class-name="myLabel" content-class-name="myContent">{{info.innerHum}}</el-descriptions-item>
                <el-descriptions-item label="仓外温度 ℃" label-class-name="myLabel" content-class-name="myContent">{{info.outerTemp}}</el-descriptions-item>
                <el-descriptions-item label="仓内湿度 %RH" label-class-name="myLabel" content-class-name="myContent">{{info.outerHum}}</el-descriptions-item>
                <el-descriptions-item label="粮食温度集合" label-class-name="myLabel" :span='2' content-class-name="myContent">{{info.grainTempCollection}}</el-descriptions-item>
                <el-descriptions-item label="粮食湿度集合" label-class-name="myLabel" :span='2' content-class-name="myContent">{{info.grainHumCollection}}</el-descriptions-item>
                <el-descriptions-item label="操作类型" label-class-name="myLabel" content-class-name="myContent">{{info.operationFlag=='i'?'新增数据':(info.operationFlag=='u'?"更新数据":"删除数据")}}</el-descriptions-item>
                <el-descriptions-item label="上传状态" label-class-name="myLabel" content-class-name="myContent">{{info.uploadSuccess=='0'?"未上传":(info.uploadSuccess=='1'?"上传成功":"上传失败")}}</el-descriptions-item>
                <el-descriptions-item label="更新时间" label-class-name="myLabel" :span='2' content-class-name="myContent">{{info.lastUpdateTime}}</el-descriptions-item>
              </el-descriptions>       
            </div>
          </div>
          <el-form-item class='saveBtn'>
            <el-button type="primary" @click="view=false">确定</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from '../../axios.js'
export default {
  props:{
    width:Number,
    height:Number
  },
  data(){
    return{
      params:{
        pageNum:1,
        pageSize:10,
        isAsc:'desc',
        wareId:''
      },
      wareList:[],
      tableData:[],
      total:0,
      info:{},
      view:false
    }
  },
  created(){
    this.getWareList()
    this.getList()
  },
  methods:{
    getWareList(){
      axios.get('/system/house/getHouseSelect').then(res=>{
        if(res.code==200){
          this.wareList=res.data;
        }
      })
    },
    wareChange(val){
      if(val){
        let item=this.wareList.find(item=>item.wareId==val);
        this.params.locationName=item.wareName;
      }else{
        this.params.locationName='';
      }
      this.getList()
    },
    getList(){
      axios.get('/system/data/list',{params:this.params}).then(res=>{
        if(res.code==200){
          this.tableData=res.rows;
          this.total=res.total
        }
      })
    },
    // refresh(){

    // },
    upload(){
      axios.get('/system/data/upload').then(res=>{
        if(res){
          this.$message({
            type: 'success',
            message: '上传成功!',
            duration:1000
          });
        }
      })
    },
    handleDelete(grainUploadDataId){
      this.$confirm('此操作将永久删除该粮温信息, 是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.delete(`/system/data/${grainUploadDataId}`).then(data=>{
          if(data){
            this.getList();
            this.$message({
              type: 'success',
              message: '删除成功!',
              duration:1000
            });
          }
        })
      })
    },
    viewInfo(grainUploadDataId){
      axios.get(`/system/data/${grainUploadDataId}`).then(res=>{
        if(res.code==200){
          this.info=res.data;
          this.view=true
        }
      })
    },
    getOtherLog(val){
      this.params.pageNum=val
      this.getList()
    },
    indexMethod(index){
      return (this.params.pageNum-1)*this.params.pageSize+index+1
    }
  }
}
</script>

<style>
/* .refresh{
  left: 140px;
} */
.upload{
  left: 15px;
}
.upWaiting{color: #3562ff}
.upOnLine{color: #3BD14A}
.upOffLine{color: #AFAFAF}
</style>
